import { render, staticRenderFns } from "./NewsVideo.vue?vue&type=template&id=0d16297b&"
import script from "./NewsVideo.vue?vue&type=script&lang=js&"
export * from "./NewsVideo.vue?vue&type=script&lang=js&"
import style0 from "./NewsVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports